import { isNull } from "lodash";

const getCoords = (data, filters) => {
  let filteredCoords = [];
  let reducedData = data;
  let foundBrands = false;

  if (!isNull(filters)) {
    Object.entries(filters).forEach(entry => {
      let key = entry[0];
      let value = entry[1];

      switch (key) {
        case "divisions":
          reducedData = reducedData.filter(place => place.division === value);
          break;
        case "countries":
          reducedData = reducedData.filter(place => place.country === value);
          break;
        case "brands":
          foundBrands = true;
          reducedData = reducedData.filter(
            place =>
              place.brands.filter(brand => brand.niceName === value).length > 0
          );
          break;
        default:
          console.error(
            "I didn't found filters divisions, countries or brands"
          );
      }

      return filteredCoords;
    });

    let count;
    reducedData.forEach(place => {
      count = 0;

      if (foundBrands) {
        for (let brand of place.brands) {
          if (brand.niceName === filters.brands) {
            count = count + parseInt(brand.count);
          }
        }
      }

      filteredCoords.push({
        geoCords: place.geoCords,
        count: foundBrands ? count : place.count,
        brands: place.brands
      });
    });
  } else {
    for (let place of data) {
      filteredCoords.push({
        geoCords: place.geoCords,
        count: place.count,
        brands: place.brands
      });
    }
  }

  return filteredCoords;
};

export default getCoords;
